import type { ConfigField } from '@chukua/common';

/** The section a field opens, when it starts one: its section differs from the field before it. Unsectioned fields open none. */
export function sectionStartingAt(fields: readonly ConfigField[], index: number): string | undefined {
  const section = fields[index]?.section;
  if (!section) return undefined;
  return fields[index - 1]?.section === section ? undefined : section;
}
